@use '@design/design-tokens/border-radius/border-radius' as *;

.styledErrorMessageRoot {
  padding: 38px 0;
  @include border-radius-r2;
}

.showBorder {
  border: 1px solid var(--border-soft);
}
